// extracted by mini-css-extract-plugin
export default {"bundle_card":"BundlePackageGroup_bundle_card__wa6cw","card_holder":"BundlePackageGroup_card_holder__x4pOm","bundle_group_content":"BundlePackageGroup_bundle_group_content__rFPbw"};